/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable import/no-extraneous-dependencies */
import { createRef, useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button, Card, CardContent, CardDescription } from "@repo/ui";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { process } from "@progress/kendo-data-query";
import { MdUpdate } from "react-icons/md";
import { Loader2 } from "lucide-react";
import { ExcelExport } from "@progress/kendo-react-excel-export";
import { PATHS } from "routes/paths";
import {
  useExportAllTickets,
  useGetAllTickets,
  useGetTasks
} from "services/tickets";
import Loader from "ui/page-loader";
import { BreadCrumb } from "ui/bread-crumbs";
import { FiltersContext } from "store/filters-context";
import UpdateStatus from "../ticketDetails/update-status";
import { StatusContext } from "../constants";
import {
  fixKendoGridContent,
  getTicketDetailsPage,
  isFilterUpdated
} from "../utils";
import FilterBarV2 from "../common/filter-bar";
import GridDataCopyCell from "components/copy";
import moment from "moment";

export default function CCAAllTicketsList() {
  const [dataState, setDataState] = useState({
    sort: [{ field: "code", dir: "asc" }]
  });

  const getSlaStageInfo = (value) => {
    let display = value;
    let bgColor = "transparent";

    switch (value) {
      case "WithinSla":
        display = "Within SLA";
        bgColor = "#2A9D8F";
        break;
      case "Breach":
      case "BreachEscalation":
        display = "Breached Escalation";
        bgColor = "#E63946";
        break;
      case "AboutToBreach":
        display = "About to Breach";
        bgColor = "#f59e0b";
        break;
      default:
        break;
    }
    return { display, bgColor };
  };

  const [tickets, setTickets] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [reload, setReload] = useState(false);

  const { filters } = useContext(FiltersContext);
  const { setStatus } = useContext(StatusContext);

  const [localFilters, setLocalFilters] = useState({
    searchCriteria: filters?.searchCriteria?.value || "",
    period: filters?.period?.value || "All",
    cashCenterId: filters?.cashCenterId?.value || "",
    customerId: filters?.customerId?.value || "",
    assetId: filters?.assetId?.value || "",
    activityType: filters?.activityType?.value || "",
    assignmentGroup: filters?.assignmentGroup?.value || "",
    status: filters?.status?.value || "All"
  });

  const pageSize = 100;
  const _exporter = createRef();

  useEffect(() => {
    const nextFilters = {
      searchCriteria: filters?.searchCriteria?.value || "",
      period: filters?.period?.value || "All",
      cashCenterId: filters?.cashCenterId?.value || "",
      customerId: filters?.customerId?.value || "",
      assetId: filters?.assetId?.value || "",
      activityType: filters?.activityType?.value || "",
      assignmentGroup: filters?.assignmentGroup?.value || "",
      status: filters?.status?.value || "All"
    };

    if (isFilterUpdated(localFilters, nextFilters)) {
      setLocalFilters(nextFilters);
    }
  }, [filters]);

  const {
    mutate: getTickets,
    data: ticketsList,
    isPending: gettingTickets
  } = useGetAllTickets();

  const {
    mutate: getTasks,
    data: tasksList,
    isPending: gettingTasks
  } = useGetTasks();

  const {
    mutate: getAllTickets,
    data: allTicketsData,
    isPending: gettingAllTickets
  } = useExportAllTickets();

  useEffect(() => {
    if (allTicketsData && _exporter.current) {
      _exporter.current.save();
    }
  }, [allTicketsData]);

  useEffect(() => {
    setCurrentPage(1);
    getTickets({
      pageNumber: 1,
      pageRowCount: pageSize,
      ...localFilters
    });
  }, [reload, localFilters]);

  useEffect(() => {
    if (!ticketsList) return;

    setTotalRecords(ticketsList.data.totalRecords);
    setTickets(
      ticketsList.data.data.map((elm) => ({
        ...elm,
        expanded: false,
        selected: false,
        vaultAccessRequired: elm.vaultAccessRequired ? "Yes" : "No",
        vaultAccessAdded: elm.vaultAccessAdded ? "Yes" : "No",
        responseSlaStage: getSlaStageInfo(elm?.responseSla?.slaStage).label,
        resolutionSlaStage: getSlaStageInfo(elm?.resolutionSla?.slaStage).label
      }))
    );
  }, [ticketsList]);

  const onPageChange = (e) => {
    const page = e.page.skip / pageSize + 1;
    setCurrentPage(page);
    getTickets({
      pageNumber: page,
      pageRowCount: pageSize,
      ...localFilters
    });
  };

  const onRefresh = () => {
    getTickets({
      pageNumber: currentPage,
      pageRowCount: pageSize,
      ...localFilters
    });
  };

  const updateCell = ({ dataItem }) => (
    <td>
      <div className="flex items-center justify-center w-full">
        <UpdateStatus
          triggerButton={
            <Button variant="outline">
              <MdUpdate fontSize="18px" />
            </Button>
          }
          onReload={() => setReload((r) => !r)}
          requestDetails={dataItem}
        />
      </div>
    </td>
  );

  const onExpandChange = ({ dataItem }) => {
    setTickets((prev) =>
      prev.map((t) =>
        t.ticketId === dataItem.ticketId
          ? { ...t, expanded: !t.expanded }
          : { ...t, expanded: false }
      )
    );
    getTasks(dataItem.ticketId);
  };

  function DetailComponent() {
    if (gettingTasks) {
      return (
        <div className="flex justify-center py-6">
          <Loader2 className="animate-spin" />
        </div>
      );
    }

    return (
      <div style={{ background: "white", padding: "12px" }}>
        <h1 className="text-md font-medium">Tasks List</h1>
        <Grid
          data={tasksList?.data || []}
          style={{ margin: "20px 0", background: "white" }}
          className="detail-grid border-2"
        >
          <GridColumn
            title="Task Number"
            width="170px"
            filterable={false}
            field="taskNo"
            cell={(items) => {
              const dataItem = items.dataItem;
              return (
                <GridDataCopyCell
                  dataItem={items.dataItem}
                  field={items.field}
                  customCell={
                    <td>
                      <Link
                        onClick={() => {
                          setStatus("all");
                        }}
                        to={`${PATHS.taskDetails}/${dataItem.requestId}`}
                      >
                        {dataItem.status === "Draft"
                          ? "View Draft"
                          : dataItem.taskNo}
                      </Link>
                    </td>
                  }
                />
              );
            }}
          />
          <GridColumn
            title="Vault Access Required"
            field="vaultAccessRequired"
            cell={(items) => {
              return (
                <GridDataCopyCell
                  dataItem={items.dataItem}
                  field={items.field}
                  customCell={
                    <td>{items.dataItem.vaultAccessRequired ? "Yes" : "No"}</td>
                  }
                />
              );
            }}
            width="170px"
          />
          <GridColumn
            title="Vault Access Added"
            field="vaultAccessAdded"
            cell={(items) => {
              return (
                <GridDataCopyCell
                  dataItem={items.dataItem}
                  field={items.field}
                  customCell={
                    <td>{items.dataItem.vaultAccessAdded ? "Yes" : "No"}</td>
                  }
                />
              );
            }}
            width="170px"
          />
          <GridColumn
            title="Assignment Group"
            field="assignmentGroup"
            width="170px"
          />
          <GridColumn title="Route No" field="routeNo" width="170px" />
          <GridColumn title="Assigned To" field="assigneeId" width="170px" />
          <GridColumn
            title="Secondary Assignee"
            field="secondaryAssigneeId"
            width="170px"
          />
          <GridColumn title="State" field="status" width="150px" />
          <GridColumn
            title="Resolution Code"
            field="resolutionCode"
            width="170px"
          />
          <GridColumn
            title="Resolution Details"
            field="resolutionDetails"
            width="170px"
          />
          <GridColumn
            title="Description"
            field="remarks"
            width="400px"
            cell={GridDataCopyCell}
          />
          <GridColumn
            title="Response SLA Stage"
            field="responseSlaStage"
            width="170px"
            headerClassName="text-center"
            className="text-center"
            cell={(items) => {
              const { display, bgColor } = getSlaStageInfo(
                items.dataItem.responseSlaStage
              );
              return (
                <td>
                  <div className="flex items-center justify-center">
                    {display ? (
                      <div
                        className="flex px-3 py-1 items-center justify-center text-sm font-medium rounded-md border"
                        style={{
                          width: "120px",
                          backgroundColor: bgColor,
                          color: bgColor === "transparent" ? "#374151" : "#fff"
                        }}
                      >
                        {display}
                      </div>
                    ) : null}
                  </div>
                </td>
              );
            }}
          />
          <GridColumn
            title="Resolution SLA Stage"
            field="resolutionSlaStage"
            width="170px"
            headerClassName="text-center"
            className="text-center"
            cell={(items) => {
              const { display, bgColor } = getSlaStageInfo(
                items.dataItem.resolutionSlaStage
              );
              return (
                <td>
                  <div className="flex items-center justify-center">
                    {display ? (
                      <div
                        className="flex px-3 py-1 items-center justify-center text-sm font-medium rounded-md border"
                        style={{
                          width: "120px",
                          backgroundColor: bgColor,
                          color: bgColor === "transparent" ? "#374151" : "#fff"
                        }}
                      >
                        {display}
                      </div>
                    ) : null}
                  </div>
                </td>
              );
            }}
          />
          <GridColumn title="Reason" field="reasons" width="170px" />
        </Grid>
      </div>
    );
  }

  return (
    <div className="box-border">
      {gettingTickets ? <Loader /> : <></>}
      <BreadCrumb
        className="mx-4"
        items={[{ text: "Dashboard", to: "/" }, { text: "All Tickets" }]}
      />
      <Card className="mx-4 mt-5">
        <CardContent>
          <CardDescription className="pt-6">
            <FilterBarV2
              exportExcel
              exportingExcel={gettingAllTickets}
              onRefresh={onRefresh}
              onExcelExport={() => {
                getAllTickets({
                  ...localFilters
                });
              }}
              pageType="service"
            />
          </CardDescription>

          <Grid
            data={process(tickets || [], dataState)}
            {...dataState}
            onDataStateChange={(e) => {
              e.dataState.skip = 0;
              setDataState(e.dataState);
            }}
            filterable
            className="list-tables-v1"
            width="100%"
            sortable
            pageable
            navigatable
            total={totalRecords}
            pageSize={pageSize}
            skip={(currentPage - 1) * pageSize}
            onPageChange={onPageChange}
            expandField="expanded"
            onExpandChange={onExpandChange}
            detail={DetailComponent}
            ref={(e) => {
              fixKendoGridContent(e);
            }}
          >
            <GridColumn
              title="Update"
              filterable={false}
              cell={updateCell}
              width="100px"
            />

            <GridColumn
              title="Open At"
              field="createDateTime"
              width="120px"
              className="text-center"
              headerClassName="text-center"
            />
            <GridColumn
              title="Resolve At"
              field="resolvedDateTime"
              width="120px"
              className="text-center"
              headerClassName="text-center"
            />
            <GridColumn
              title="State"
              field="status"
              width="150px"
              className="text-center"
              headerClassName="text-center"
            />
            <GridColumn title="Account" field="customer" width="170px" />
            <GridColumn title="Asset Id" field="locationId" width="150px" />
            <GridColumn
              title="Ticket Number"
              width="170px"
              field="caseNo"
              cell={(items) => {
                const dataItem = items.dataItem;
                return (
                  <GridDataCopyCell
                    dataItem={items.dataItem}
                    field={items.field}
                    customCell={
                      <td>
                        <Link
                          onClick={() => {
                            setStatus("all");
                          }}
                          to={getTicketDetailsPage(dataItem)}
                        >
                          {dataItem.status === "Draft"
                            ? "View Draft"
                            : dataItem.caseNo}
                        </Link>
                      </td>
                    }
                  />
                );
              }}
            />

            <GridColumn
              title="Bank Reference/Address"
              field="customerTicketNo"
              width="200px"
            />
            <GridColumn
              title="Activity Type"
              field="activityType"
              width="170px"
            />
            <GridColumn title="Category" field="category" width="150px" />
            <GridColumn
              title="Sub Category"
              field="subCategory"
              width="150px"
            />
            <GridColumn title="Location" field="locationName" width="170px" />
            <GridColumn title="Region" field="region" width="150px" />
            <GridColumn
              title="Assignment Group"
              field="assignmentGroup"
              width="170px"
            />

            <GridColumn title="Reported By" field="reportedBy" width="170px" />
            <GridColumn
              title="Description"
              field="remarks"
              width="400px"
              cell={GridDataCopyCell}
            />
            <GridColumn
              title="Resolution Notes"
              field="resolutionNotes"
              width="170px"
              cell={GridDataCopyCell}
            />
          </Grid>
          <ExcelExport
            data={allTicketsData?.data.data || []}
            fileName="All_Tickets.xlsx"
            ref={_exporter}
          >
            <GridColumn
              title="TG Reference Number"
              width="170px"
              field="caseNo"
            />

            <GridColumn
              title="Bank Reference/Address"
              field="customerTicketNo"
            />

            <GridColumn
              title="Created At"
              field="createDateTime"
              width="170px"
            />
            <GridColumn title="Opened By" field="openedBy" width="170px" />
            <GridColumn title="Account" field="customer" width="170px" />
            <GridColumn title="Asset Id" field="locationId" width="150px" />
            <GridColumn title="Location" field="locationName" width="170px" />
            <GridColumn title="Region" field="region" width="150px" />
            <GridColumn
              title="Activity Type"
              field="activityType"
              width="170px"
            />
            <GridColumn title="Category" field="category" width="150px" />
            <GridColumn
              title="Sub Category"
              field="subCategory"
              width="150px"
            />
            <GridColumn title="Chargeable" field="chargeable" width="200px" />
            <GridColumn title="Description" field="remarks" width="170px" />
            <GridColumn
              title="Assignment Group"
              field="assignmentGroup"
              width="170px"
            />

            <GridColumn
              title="Closed Date"
              field="closedDateTime"
              width="200px"
            />
            <GridColumn title="Closed By" field="closedBy" width="200px" />
            <GridColumn title="State" field="status" width="200px" />
            <GridColumn title="Priority" field="priority" width="200px" />
            <GridColumn
              title="Resolution Notes"
              field="resolutionNotes"
              width="170px"
            />
          </ExcelExport>
        </CardContent>
      </Card>
    </div>
  );
}
